import { ForwardedRef } from 'react'
import cx from 'classnames'

import { User } from 'lib/_types'

import LoadMore from '../LoadMore'
import { UserListItem } from './UserListItem'

export type UserList = {
  users: User[]
  isLoading?: boolean
  showLoadMore?: boolean
  onLoadMore?: () => void
  loadMoreRef?: ForwardedRef<HTMLAnchorElement>
  listRef?: ForwardedRef<HTMLDivElement>
  mode?: 'list' | 'grid' | 'scroll'
  fullWidth?: boolean
  itemsPerRow?: 2 | 3 | 4 | 5 | 6 | 7 | 8
  size?: 'small' | 'normal'
  followCallbackSetter?: Function
  clickUserCallback?: Function // used for UserList modals (UserFollowerModal, UserFollowingModal)
  className?: string
  filterCondition?: (x: User) => boolean
} & Omit<UserListItem, 'user' | 'itemIndex'>

export const UserList = ({
  users,
  isLoading,
  showLoadMore,
  onLoadMore,
  loadMoreRef = null,
  listRef = null,
  mode = 'list',
  fullWidth,
  itemsPerRow = 3,
  size = 'normal',
  className,
  filterCondition = (x: User) => true,
  ...userItemProps
}: UserList) => {
  return (
    <>
      <div
        className={cx('UserList', {
          [`UserList--grid UserList--grid--${itemsPerRow}`]: mode === 'grid',
          'UserList--scroll': mode === 'scroll',
          'UserList--fullWidth': fullWidth,
          [`UserList--${size}`]: size,
          [className]: className,
        })}
        ref={listRef}
      >
        {users.filter(filterCondition).map((user, i) => (
          <UserListItem
            key={user.id}
            user={user}
            itemIndex={i}
            {...userItemProps}
          />
        ))}
      </div>

      <LoadMore
        isLoading={isLoading}
        ref={loadMoreRef}
        onClick={onLoadMore}
        hidden={!showLoadMore}
        className="UserList__load-more"
      />
    </>
  )
}
